import Structure from "./Structure/Structure";
import XmlService from "@/services/Xml/XmlService";
import FormController from "./FormController";
import EventSystem from "./Events/EventSystem";
import Translation from "./Translation/Translation";
import StorageService from "./Storage/StorageService";
import FunctionalityService from "./Functionality/FunctionalityService";
import Signer from "./DSigner/Signer";

export default class FormEngine {
  public appInstance: any;
  public modules: Dictionary<any> = {};

  public formBuilder: any;

  public structure: Structure = new Structure();
  public form: FormController;
  public events = EventSystem;
  public translation = Translation;
  public functionality = FunctionalityService;
  public rules: Dictionary<any> = {};


  public engineConfig: IEngineConfig;
  public xmlService: XmlService;
  public storage = StorageService;
  public signer: Signer;

  constructor(engineConfig: any, defaultXml: string) {
    this.signer = new Signer;
    this.events.publish(this.events.list.ENGINE_BEFORE_INIT, {
      formEngine: this,
      engineConfig: engineConfig,
      defaultXml: defaultXml,
    });
    this.engineConfig = engineConfig;
    this.form = new FormController(engineConfig.rootElementIdSelector);

    this.events.publish(this.events.list.XML_BEFORE_INIT, defaultXml);
    this.xmlService = new XmlService(defaultXml);
    this.events.publish(this.events.list.XML_AFTER_INIT, this.xmlService);

    this.events.publish(this.events.list.ENGINE_AFTER_INIT, {
      formEngine: this,
    });
    return this;
  }

  public registerVueApp(app: any) {
    app.config.globalProperties.$FormEngine = this;
    this.appInstance = app;

  }

  public registerFormFunctionality() {
    let rules = window.FormEngine.structure.functionality;
    //console.log(rules);
    //console.log(rules);
    if (rules) {
      for (let ruleName in rules) {
        let ruleStack = rules[ruleName];
        let ruleJson = JSON.parse(ruleStack.ExpressionText);
        let storageObject: { [key: string]: any } = {};
        storageObject.$rule = ruleJson;
        let builtFunct = this.functionality.builder(ruleJson.ruleStack.length > 0 ? ruleJson.ruleStack : ruleJson.functionStack, storageObject);
        builtFunct();
        this.rules[ruleName] = {
          storage: storageObject,
          func: builtFunct,
        };
      }
    } else {
      console.log("Form has no functionality from builder.");
    }
  }

  public async loadStructure(structureJSON: IStructure) {
    await this.structure.loadStructureJSON(structureJSON);
    //TODO: explore compiled templates for components and their storage in localStorage
    //this.structure.compileCustomTemplates();
  }
}
